/* User-facing branding only. Current application identity. */
(function(root,factory){const api=factory();if(typeof module==='object')module.exports=api;else{root.MyersCADBrand=api;api.apply(document);}})(typeof window==='object'?window:this,()=>{'use strict';
 function apply(doc){
  doc.title='MyersCAD 1.64 — Simple 3D CAD';
  const script=doc.currentScript;if(script?.src)doc.documentElement.style.setProperty('--myerscad-icon','url("'+new URL('myerscad-icon.svg',script.src).href+'")');
  const brand=doc.querySelector('.brand');if(brand){for(const node of brand.childNodes)if(node.nodeType===3)node.textContent=node.textContent.replace(/myerscad/gi,'MyersCAD');if(!brand.getAttribute('aria-label')?.includes('MyersCAD'))brand.setAttribute('aria-label','MyersCAD — Simple 3D CAD');}
  const version=doc.querySelector('footer span:last-child');if(version?.textContent==='Studio 1.64')version.textContent='MyersCAD 1.64';
 }
 return {apply};
});
